<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="3" class="d-none d-md-flex">
                <TableCategory />
            </v-col>
            <v-col cols="12" md="9">
                <v-row>
                    <v-col cols="12" md="6">
                        <div class="resp-container mb-4" v-if="contact.map !== undefined && contact.map !== null">
                            <iframe class="resp-iframe" :src="contact.map" gesture="media"  allow="encrypted-media" allowfullscreen frameborder="0" style="border:0;" aria-hidden="false" tabindex="0"></iframe>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="title mb-1">
                            <span class="text-h4">Promo</span>
                        </div>
                        <v-list disabled>
                            <v-list-item-group>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon class="icon-contact">fas fa-map-marker-alt</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="contact.address"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon class="icon-contact">fas fa-phone-alt</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="contact.phone"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon class="icon-contact">fas fa-clock</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="contact.hour"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import TableCategory from '@/components/TableCategory.vue';
    export default {
        props: ['id'],
        components: {
            TableCategory
        },
        data: () => ({
            contact: {}
        }),
        mounted() {
            this.$store.dispatch('requestAPI', {
                name: 'contact-us',
                params: {}
            }).then(async response => {
                this.contact = response.data.result;
                console.log(this.contact);
            });
        },
    }
</script>